import type { StorageResponsePayload } from "@swiggy-private/native-bridge";
import { STORAGE_TYPES } from "@swiggy-private/native-bridge";
import { webStorage } from "@swiggy-private/portal-dineout-ui";
import { getBridgeSdk } from "./bridgeSdk";
import { isApp } from "./browser";
import { WebStorageLocation } from "../types";

export const getFromStorage = async (
    key: string,
    storageType: WebStorageLocation = WebStorageLocation.LOCAL,
    isWebStorage = false,
): Promise<StorageResponsePayload | undefined> => {
    try {
        const payload = {
            type: STORAGE_TYPES.GET,
            data: { [key]: "" },
        };
        if (isApp() && !isWebStorage) {
            return await getBridgeSdk().storage(payload);
        } else {
            return (await webStorage(payload, storageType)) as StorageResponsePayload;
        }
    } catch (_error) {
        return {
            data: {
                [key]: "",
            },
        };
    }
};

export const saveToStorage = async (
    key: string,
    value: string,
    storageType: WebStorageLocation = WebStorageLocation.LOCAL,
): Promise<StorageResponsePayload | undefined> => {
    try {
        const payload = {
            type: STORAGE_TYPES.SAVE,
            data: { [key]: value },
        };
        if (isApp()) {
            return await getBridgeSdk().storage(payload);
        } else {
            return (await webStorage(payload, storageType)) as StorageResponsePayload;
        }
    } catch (_error) {
        return {
            data: {
                [key]: "",
            },
        };
    }
};

export const deleteFromStorage = async (
    key: string,
    storageType: WebStorageLocation = WebStorageLocation.LOCAL,
    isWebStorage = false,
): Promise<void> => {
    try {
        const payload = {
            type: STORAGE_TYPES.DELETE,
            data: {
                [key]: "",
            },
        };

        if (isApp() && !isWebStorage) {
            getBridgeSdk().storage(payload);
        } else {
            await webStorage(payload, storageType);
        }
    } catch (_) {}
};
